module.exports = __webpack_public_path__ + "static/electricity2-0636ef66ff63490ee2f63d239aad9220.png";